export class EntMovablePropertyFilter {
  page: number = 1;
  size: number = 30;
  name: string | null = null;
  brand: string | null = null;
  model: string | null = null;
  periodStart: string | null = null;
  periodEnd: string | null = null;
  territorialUnitIds: number[] | null = null;
  conditionIds: number[] | null = null;
  governmentIds: number[] | null = null;
  deleted: boolean = false
}